export const DATE_ONLY_FORMAT = 'MM/DD/YYYY';
export const DATE_TIME_FORMAT = 'MM/DD/YYYY HH:mm A z';
export const EXPORT_DATE_FORMAT = 'YYYY-MM-DD';
export const DISPLAY_EMPTY = '--';
export const INITIAL_QUANTITY_VALUE = -1;
export const INITIAL_SELECT_ID = -1;
export const US_ORG_ID = 121;
export const CANADA_ORG_ID = 201;
export const ALL_OPERATING_UNIT = 'All';
export const LOADING_TEXT = 'Loading...';
export const NO_OPTION_TEXT = 'No options';
export const SERVER_TIMEZONE = 'America/Los_Angeles';
export const ACTION_REQUESTED_MAX_LENGTH = 1000;
export const JUSTIFICATION_MAX_LENGTH = 1000;
export const COMMENT_MAX_LENGTH = 1000;
export const SYSTEM_EMPLOYEE_ID = 162;
export const MAX_COUNT = 2147483647;
export const AM_LIST_PAGE_NAME = 'AM List';
export const AM_LIST_PATH_NAME = '/amlist';
export const PROJECT_UNDER_CONSTRUCTION_ERROR = 'Project under construction';
export const MINIMUM_COMPLETION_DAYS = 30;
export const MAXIMUM_COMPLETION_DAYS = 3650;
export const REMINDER_DAYS = 14;
export const CONTRACT_SIGNER_ORIGIN = 'SIGNER';
export const MANUAL_ORIGIN = 'MANUAL';
export const PROJECT_MANAGER_ROLE_ID = 1;

export enum AmStatusType {
    Approved = 'Approved',
    Cancelled = 'Cancelled',
    Closed = 'Closed',
    Draft = 'Draft',
    Hold = 'Hold',
    Inactive = 'Inactive',
    Pending = 'Pending',
    Rejected = 'Rejected',
    Voided = 'Voided',
}

export enum ApproverRoutingStatusType {
    CURRENT = 'C',
    APPROVED = 'A',
    NOT_APPROVED = 'N',
    SKIPPED = 'S',
}

export enum ViewerRoleType {
    Admin = 1000,
    Viewer = 1001,
}

export enum AdminAuthorizationType {
    Organization = 'ORGANIZATION',
    Person = 'PERSON',
}

export const AM_NUMBER_REGEX = /^\d{6}(-\d{1,3})?$/g;

export const DEFAULT_INITIAL_STATE = {
    pageSize: 20,
    pageIndex: 0,
    sortBy: [],
};

export const DEFAULT_ADMIN_PAGE_SIZE = 100;

export const DEFAULT_ADMIN_INITIAL_STATE = {
    pageSize: DEFAULT_ADMIN_PAGE_SIZE,
    pageIndex: 0,
    sortBy: [],
};
